import { BaseComponent } from 'src/app/shared/component/base-component/base.component';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { SvgIcon } from '../../interfaces';

@Component({
  selector: 'app-svg-icon',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './svg-icon.component.html',
  styleUrls: ['./svg-icon.component.scss'],
})
export class IconSvgComponent extends BaseComponent implements OnInit {
  @Input() icon: SvgIcon;
  @Input() iconTitle : string;
  constructor(injector: Injector) {
    super([], injector);
  }
  ngOnInit(): void {
    this.injector
      .get(MatIconRegistry)
      .addSvgIconLiteral(this.icon.iconName, this.injector.get(DomSanitizer).bypassSecurityTrustHtml(this.icon.icon));
  }
}
